import React, {Component, Fragment} from 'react';

export const initData = {
    locale_count:           0,
    locale_total_count:     0,
    locale_rate:            0,

    total_count:            0,
    total_total_count:      0,
    total_rate:             0,

    nursery_count:          0,
    nursery_total_count:    0,
    nursery_rate:           0,

    daycare_count:          0,
    daycare_total_count:    0,
    daycare_rate:           0,

    null_count:             0,
}

class ArrowInfo extends Component {
	render(){
		
		if(this.props.rate == 0) {
			return (
					<div className="d-inline-block float-right text-info" style={{}}>
						<span className="text-muted"></span>
                        {this.props.showArrow !== undefined && this.props.showArrow == true ? (
                        <span className="icon-circle-small icon-box-xs bg-info-light"><i className="fa fa-fw fa-arrow-right"></i></span>) : ''}						
						<span className="ml-1">{this.props.rate}{this.props.isRate ? "%" :""} </span>
					</div>
			)
		} else if(this.props.rate > 0) {
			return (
					<div className="d-inline-block float-right text-success" style={{}}>
						<span className="text-muted mb"></span>
						{this.props.showArrow !== undefined && this.props.showArrow == true ? (
                        <span className="icon-circle-small icon-box-xs bg-success-light"><i className="fa fa-fw fa-arrow-up"></i></span>) : ''}	
						<span className="ml-1">{this.props.rate}{this.props.isRate ? "%" :""}</span>
					</div>
			)
		} else {
			return (
					<div className="d-inline-block float-right text-danger" style={{}}>
						<span className="text-muted"></span>
						{this.props.showArrow !== undefined && this.props.showArrow == true ? (
                        <span className="icon-circle-small icon-box-xs bg-danger-light"><i className="fa fa-fw fa-arrow-down"></i></span>) : ''}	
						<span className="ml-1">{this.props.rate*-1}{this.props.isRate ? "%" :""}</span>
					</div>
			)
		}
		
	}
}

class Card extends Component {

	constructor(props) {
		super(props);
	}

	render() {

		return (
			<div className="card border-top border-3 border-top-primary">
				<div className="card-body" style={{padding : "11px 20px"}}>
					<h5 className="text-muted mb-1">
						{this.props.title}
						{/* <div className="metric-value d-inline-block float-right">
							<h5 className="mb-1">
								{
									this.props.rate != null ? <ArrowInfo rate={this.props.rate} isRate={this.props.isRate == null ? true : this.props.isRate} /> : null
								}
							</h5>
						</div> */}
					</h5>
                    <div className="text-right">
						<h4 className="mb-1">{this.props.value}</h4>
                    </div>
                    {(this.props.isRate === true) ? (
                        <div className="">
                            <div className="progress progress-lg text-center" style={{background:"#8c8c8c"}}>
                                <span className="progress-value">{this.props.rate + "%"}</span>
                                <div className="progress-bar" role="progressbar" style={{width: this.props.rate+"%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"/>
                            </div>
                        </div>
                    ): (
                        <div className="mb-3">
                        </div>
                    )
                    }
				</div>
			</div>
		)
		
		
	}

}

export default class ContractCards extends Component {

	constructor(props) {
        super(props);
        this.state = {
            year : this.props.year,
            ...initData
        }
    }

    componentWillReceiveProps = (nextProps) => {       
        if(!nextProps.data || !this.state.year || !nextProps.data[this.state.year])
            return

        this.setState({
            year:                   nextProps.year,
            locale_count:           nextProps.data[this.state.year].locale_count,
            locale_total_count:     nextProps.data[this.state.year].locale_total_count,
            locale_rate:            nextProps.data[this.state.year].locale_rate,
            
            total_count:            nextProps.data[this.state.year].total_count,
            total_total_count:      nextProps.data[this.state.year].total_total_count,
            total_rate:             nextProps.data[this.state.year].total_rate,
            
            nursery_count:          nextProps.data[this.state.year].nursery_count,
            nursery_total_count:    nextProps.data[this.state.year].nursery_total_count,
            nursery_rate:           nextProps.data[this.state.year].nursery_rate,
            
            daycare_count:          nextProps.data[this.state.year].daycare_count,
            daycare_total_count:    nextProps.data[this.state.year].daycare_total_count,
            daycare_rate:           nextProps.data[this.state.year].daycare_rate,

            null_count:             nextProps.data[this.state.year].null_count,
        }, () => {
        })
    }

    

	render() {

		return (
			<Fragment>
				<div className="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
                    <Card title="전국 지역" value={this.state.locale_count.toLocaleString() + " / " + this.state.locale_total_count.toLocaleString()}
                        rate={this.state.locale_rate} isRate={true} />
				</div>
				<div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-12">
                    <div className="row">
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                            <Card title="전체" value={(this.state.total_count).toLocaleString() + ' / ' + (this.state.total_total_count).toLocaleString()}
                                rate={this.state.total_rate} isRate={true} />
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                            <Card title="유치원" value={(this.state.nursery_count).toLocaleString() + ' / ' + (this.state.nursery_total_count).toLocaleString()}
                                rate={this.state.nursery_rate} isRate={true} />
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                            <Card title="어린이집" value={(this.state.daycare_count).toLocaleString() + ' / ' + (this.state.daycare_total_count).toLocaleString()}
                                rate={this.state.daycare_rate} isRate={true} />
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                            <Card title="기타" value={(this.state.null_count).toLocaleString()}
                                isRate={false} />
                        </div>
                    </div>
				</div>
			</Fragment>
		)
	}
}

